<template>
    <div id="empty-page"></div>
</template>

<script>
export default {
    name: 'EmptyPage',
}
</script>
